// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AEInput,
  AEFile,
  AEAutoComplete,
  AECheckbox,
  AEDatePicker,
} from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { actionTypes as countriesActionTypes } from "../../../Countries/_redux/slice";
import { actionTypes as categoriesActionTypes } from "../../../Categories/_redux/slice";
import { actionTypes as subCategoriesActionTypes } from "../../../Subcategories/_redux/slice";
import { actionTypes as projectTypesActionTypes } from "../../../ProjectTypes/_redux/slice";
// import { actionTypes as locationsActionTypes } from "../../../Locations/_redux/slice";
import { actionTypes as paymentTermsActionTypes } from "../../../PaymentTerms/_redux/slice";
import { actionTypes as skillsActionTypes } from "../../../Skills/_redux/slice";
import { fetchEntities as getCategories } from "../../../Categories/_redux/actions";
import { AEMetadata, defaultMeta } from "../../../../../_emywork/AEPagination";
import {
  localField,
  PAYMENT_TERMS,
  PTermsHelpers,
} from "../../../../../_emywork/helpers/UIHelper";
import { fetchEntities as getProjectTypes } from "../../../ProjectTypes/_redux/actions";
import { fetchEntities as getCountries } from "../../../Countries/_redux/actions";
import { fetchEntities as getPaymentTerms } from "../../../PaymentTerms/_redux/actions";
import {
  fetchEntities as getSubCategories,
  resetEntities as resetSubcategories,
} from "../../../Subcategories/_redux/actions";
// import {
//   fetchEntities as getLocations,
//   resetEntities as resetLocations,
// } from "../../../Locations/_redux/actions";
import {
  fetchEntities as getSkills,
  resetEntities as resetSkills,
} from "../../../Skills/_redux/actions";
import { getIntlMessage } from "../../../../../_metronic/i18n";
import { InputAdornment, TextField } from "@material-ui/core";

import { CURRENCIES } from "../../../../../_emywork/components/Currency";

import LocationField from "../../../../../_metronic/layout/components/fields/LocationField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export function EditForm({
  entity,
  btnRef,
  saveEntity,
  validationErrors = [],
}) {
  const dispatch = useDispatch();

  const searchSkills = (e) => {
    dispatch(
      getSkills(
        new AEMetadata({}, {}, { search: e.target.value }, [
          "id",
          localField("name"),
        ]),
        skillsActionTypes.ProjectFilter
      )
    );
  };
  const { formatMessage } = useIntl();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity,
    initialErrors: validationErrors,
    validationSchema: Yup.object().shape({
      title: Yup.string()
        .max(70)
        .required(),
      description: Yup.string()
        .test(
          "description",
          getIntlMessage(
            { id: "VALIDATION.STRING.WHITESPACE" },
            { path: "description" }
          ),
          (value) => !value.includes("  ")
        )
        .min(400)
        .required(),
      category_id: Yup.number().required(),
      subcategory_id: Yup.number().required(),
      // skills: Yup.array().of(Yup.number()),
      project_type_id: Yup.number().required(),
      payment_term_id: Yup.number().required(),
      country_id: Yup.number(),
      // location_id: Yup.number().required(),TODO activate the validation
      price: Yup.number().when("payment_term_id", {
        is: (id) =>
          id && PTermsHelpers.isKnown(PTermsHelpers.getKey(payment_terms, id)),
        then: Yup.number()
          .positive()
          .required(),
      }),
      hours_per_week: Yup.number().when("payment_term_id", {
        is: (id) =>
          id && PTermsHelpers.isHourly(PTermsHelpers.getKey(payment_terms, id)),
        then: Yup.number()
          .positive()
          .integer()
          .required()
          .max(Yup.ref("duration")),
      }),
      duration: Yup.number().when("payment_term_id", {
        is: (id) =>
          id && PTermsHelpers.isHourly(PTermsHelpers.getKey(payment_terms, id)),
        then: Yup.number()
          .positive()
          .integer()
          .required()
          .min(Yup.ref("hours_per_week")),
      }),
      is_private: Yup.bool(),
      quotes_end_at: Yup.string(),
      attachments: Yup.array(),
    }),
    onSubmit: (values) => {
      let skills = values.skills.map((s) => s.id);
      let {
        title,
        description,
        category_id,
        subcategory_id,

        project_type_id,
        payment_term_id,
        location_id,
        price,
        hours_per_week,
        duration,
        is_private,
        quotes_end_at,
        attachments,
      } = values;

      let entity = {
        user_id,
        title,
        description,
        category_id,
        subcategory_id,
        skills,
        project_type_id,
        payment_term_id,
        location_id,
        is_private,
        quotes_end_at,
      };
      let files = { project_attachments: attachments };

      const _k = PTermsHelpers.getKey(payment_terms, payment_term_id);
      if (PTermsHelpers.isKnown(_k)) {
        entity.price = price;
        if (PTermsHelpers.isHourly(_k)) {
          entity.hours_per_week = hours_per_week;
          entity.duration = duration;
        }
      }
      // console.log({ entity });
      saveEntity(entity, files);
    },
    // validateOnChange: (values) => console.log({ values }),
  });

  const {
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    setValues,
  } = formik;
  const {
    countries,
    categories,
    subcategories,
    skills,
    project_types,
    // locations,
    payment_terms,
    user_id,
  } = useSelector((state) => {
    const { entities: countries } = state.countries[
      countriesActionTypes.ProjectFilter
    ];
    const { entities: categories } = state.categories[
      categoriesActionTypes.ProjectFilter
    ];
    const { entities: subcategories } = state.subcategories[
      subCategoriesActionTypes.ProjectFilter
    ];
    const { entities: project_types } = state.project_types[
      projectTypesActionTypes.ProjectFilter
    ];
    // const { entities: locations } = state.locations[
    //   locationsActionTypes.ProjectFilter
    // ];
    const { entities: payment_terms } = state.payment_terms[
      paymentTermsActionTypes.ProjectFilter
    ];
    const { entities: skills } = state.skills[skillsActionTypes.ProjectFilter];

    return {
      countries,
      categories,
      subcategories,
      skills,
      project_types,
      // locations,
      payment_terms,
      user_id: state.auth.user.id,
    };
  }, shallowEqual);

  useEffect(() => {
    dispatch(getCategories(defaultMeta, categoriesActionTypes.ProjectFilter));
    dispatch(
      getProjectTypes(defaultMeta, projectTypesActionTypes.ProjectFilter)
    );
    dispatch(getCountries(defaultMeta, countriesActionTypes.ProjectFilter));
    dispatch(
      getPaymentTerms(
        new AEMetadata({}, {}, {}, ["id", localField(), `_key`]),
        paymentTermsActionTypes.ProjectFilter
      )
    );
  }, [dispatch]);

  useEffect(() => {
    if (values.category_id) {
      dispatch(
        getSubCategories(
          new AEMetadata({}, {}, { category_id: values.category_id }, [
            "id",
            "skills",
            localField(),
          ]),
          subCategoriesActionTypes.ProjectFilter
        )
      );
    } else {
      setFieldValue("subcategory_id", undefined);
      dispatch(resetSubcategories(subCategoriesActionTypes.ProjectFilter));
    }
  }, [values.category_id]);

  useEffect(() => {
    if (values.subcategory_id) {
      dispatch(
        getSkills(
          new AEMetadata({}, {}, { subcategories: [values.subcategory_id] }, [
            "id",
            localField(),
          ]),
          skillsActionTypes.ProjectFilter
        )
      );
    } else {
      setFieldValue("skills", []);
      dispatch(resetSkills(skillsActionTypes.ProjectFilter));
    }
  }, [values.subcategory_id]);

  // useEffect(() => {
  //   if (values.country_id) {
  //     dispatch(
  //       getLocations(
  //         new AEMetadata({}, {}, { country_id: values.country_id }, [
  //           "id",
  //           localField(),
  //         ]),
  //         subCategoriesActionTypes.ProjectFilter
  //       )
  //     );
  //   } else {
  //     setFieldValue("location_id", undefined);
  //     dispatch(resetLocations(locationsActionTypes.ProjectFilter));
  //   }
  // }, [values.country_id]);

  const _props = (name, label, type) => {
    let p = {
      name,
      label,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type) {
      case "autocomplete":
        {
          p.useId = true;
          p.getOptionLabel = (o) => o[localField()];
        }
        break;
    }

    return p;
  };

  return (
    <>
      <div className="form form-label-right">
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput {..._props("title", "TITLE")} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput
              type={"textarea"}
              rows={10}
              {..._props("description", "DESCRIPTION")}
            />
            <small>
              {formatMessage(
                { id: "VALIDATION.TEXT.LENGTH" },
                { value: values.description.length }
              )}
            </small>
          </div>
        </div>

        <div className="form-group row py-1">
          <div className={`col-lg-${values.category_id ? "6" : "12"}`}>
            <AEAutoComplete
              {..._props("category_id", "CATEGORY", "autocomplete")}
              options={categories}
            />
          </div>
          {values.category_id && (
            <div className={`col-lg-6`}>
              <AEAutoComplete
                {..._props("subcategory_id", "SUBCATEGORY", "autocomplete")}
                options={subcategories}
                disabled={!values.category_id}
              />
            </div>
          )}
        </div>
        {values.subcategory_id && (
          <div className="form-group row py-1">
            <div className={`col-lg-12`}>
              {/* <AEAutoComplete
                {..._props("skills", "SKILLS", "autocomplete")}
                options={skills}
                multiple
              /> */}
              {/* TODO: refactor to reusable component*/}
              <Autocomplete
                name="skills"
                options={skills}
                value={formik.values.skills}
                getOptionLabel={(o) => o[localField("name")]}
                multiple
                onChange={(e, v) => {
                  // console.log({ v });
                  setFieldValue("skills", v);
                }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Skills"
                    placeholder="Skills"
                    onChange={(e) => searchSkills(e)}
                    className="bg-white rounded"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>
        )}
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEFile
              {..._props("attachments", "ATTACHMENTS", "autocomplete")}
              multiple
              accept={
                "image/*,text/plain, application/pdf, .zip, .rar, .7zip, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,"
              }
            />
          </div>
        </div>
        <div className="form-group d-lg-flex py-1">
          <div className={`flex-lg-fill px-2`}>
            <AEAutoComplete
              {..._props("project_type_id", "TYPE", "autocomplete")}
              options={project_types}
            />
          </div>

          <div className={`flex-lg-fill px-2`}>
            <AEAutoComplete
              {..._props("country_id", "COUNTRY", "autocomplete")}
              options={countries}
              validation={false}
            />
          </div>
          {values.country_id && (
            <div className={`flex-lg-fill px-2`}>
              {/* <AEAutoComplete
                {..._props("location_id", "LOCATION", "autocomplete")}
                options={locations}
              /> */}

              <LocationField
                dispatch={dispatch}
                setFieldValue={setFieldValue}
                className="bg-white rounded"
                dispatchedAction={"ProjectFilter"}
                variant="outlined"
              />
            </div>
          )}
        </div>
        <div className="form-group row py-1">
          <div className={`col-lg-4`}>
            <AECheckbox {..._props("is_private", "INVITE_ONLY")} />
          </div>
          <div className={`col-lg-4`}>
            <AEDatePicker {..._props("quotes_end_at", "QUOTE_END_DATE")} />
          </div>
          <div className={`col-lg-4`}>
            <AEAutoComplete
              {..._props("payment_term_id", "PAYMENT_TERM", "autocomplete")}
              options={payment_terms}
            />
          </div>
        </div>
        {values.payment_term_id &&
          PTermsHelpers.isKnown(
            PTermsHelpers.getKey(payment_terms, values.payment_term_id)
          ) && (
            <div className="form-group d-lg-flex py-1">
              <div className="flex-fill pr-2">
                <AEInput
                  {..._props("price", "PRICE")}
                  type={"number"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {CURRENCIES.MAD}
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              {PTermsHelpers.getKey(payment_terms, values.payment_term_id) ===
                PAYMENT_TERMS.HOURLY && (
                <>
                  <div className="flex-fill pr-2">
                    <AEInput
                      {..._props("hours_per_week", "HOURS_PER_WEEK")}
                      type={"number"}
                    />
                  </div>
                  <div className="flex-fill">
                    <AEInput
                      {..._props("duration", "TOTAL_HOURS")}
                      type={"number"}
                    />
                  </div>
                </>
              )}
            </div>
          )}
        <button
          style={{ display: "none" }}
          ref={btnRef}
          onClick={() => {
            handleSubmit();
          }}
        />
      </div>
    </>
  );
}
